import { createSelector } from '@reduxjs/toolkit';
import { DealType } from 'components/common/types/Deal.types';
import { Store } from 'components/common/types/Store.types';
import { isValidCPMValues } from 'utils/cpmValidationUtil';
import { getDealType } from './getDealType';

export const getAreResellerLinesValid = createSelector(
  [
    (state: Store) => state.dealManagement.backupFormData.lines,
    (state: Store) => state.dealManagement.commonDeal.currentLine,
    (state: Store) => state.dealManagement.commonDeal.cpm,
    (state: Store) => state.reseller.isInternalPublisher,
  ],
  (lines, currentLine, dealCPM, hasVIOOHSelectFeatures) => {
    return lines.every((line) => {
      const lineData = line.lineId === currentLine.lineId || !currentLine.lineId ? currentLine : line;

      if (!(lineData.name && lineData.startDate && lineData.endDate)) return false;

      if (!lineData.mediaOwnerMeta?.length) return false;

      if (!isValidCPMValues(dealCPM, lineData.minCPM, lineData.maxCPM)) {
        return false;
      }

      if (hasVIOOHSelectFeatures) {
        if (lineData.mediaOwnerMeta.some((meta) => 'fee' in meta && meta.fee == null)) return false;

        if (!lineData.maxCPM) {
          return false;
        }
      }

      return true;
    });
  },
);

export const getAreProgrammaticLinesValid = createSelector(
  [
    (state: Store) => state.dealManagement.backupFormData.lines,
    getDealType,
    (state: Store) => state.dealManagement.commonDeal.currentLine,
  ],
  (lines, dealType, currentLine) =>
    lines.every((line) => {
      const lineData = line.lineId === currentLine.lineId || !currentLine.lineId ? currentLine : line;

      if (!(lineData.name && lineData.startDate && lineData.endDate)) return false;
      if (!lineData.environments?.length) return false;

      if (dealType === DealType.GUARANTEED && !lineData.impressions && !lineData.budget) {
        return false;
      }

      return true;
    }),
);
